import { Box } from '@material-ui/core';

import { ApplicationStage } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/Progress/ProgressTimeline/components/ApplicationStage';
import { ProgressStepStatus } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/Progress/_shared/types';
import { AbstractProgress } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/Progress/AbstractProgress';

interface ProgressTimelineProps {
  progress: AbstractProgress;
}

export const ProgressTimeline = ({ progress }: ProgressTimelineProps) => {
  if (!progress || !progress.statuses || !progress.progressStages || !progress.currentStep) {
    return null;
  }

  const lastStatusStep = progress.currentStep;
  //const lastStatusStep = progress.statuses[progress.statuses.length - 1];

  return (
    <Box display={'flex'} flexDirection={'column'} width={'100%'}>
      {Object.values(progress.progressStages)
        .filter((stage) => !!stage)
        .map((stage, i) => {
          const progressStepDetails = progress.getProgressStepDetails(stage[0]);

          if (progressStepDetails?.status !== ProgressStepStatus.COMPLETED && !progress.isActive) {
            return null;
          }

          return <ApplicationStage key={`application-progress-stage-${i}`} stage={stage} progress={progress} />;
        })}
      {!progress.isActive && <ApplicationStage stage={[lastStatusStep]} progress={progress} />}
    </Box>
  );
};
